import React from 'react';
import { SyncLoader } from 'react-spinners';

const Loading = () => {
    return <SyncLoader style={{display:'flex',justifyContent:'center',}} />
};

export default Loading;